/* fiveaven : mails de confirmation Klaviyo (23/10/2026), par le serveur de l'app (proxy /apps/fiveaven/notifier).
   Formulaires de contact Shopify (candidature, rétractation, contact) : les champs utiles sont gardés dans la session à l'envoi,
   et le mail n'est demandé qu'une fois le formulaire accepté par Shopify (page « bien reçu »). Le formulaire Shopify part
   toujours vers hello@fiveaven.com comme avant.
   Compte prêt : cliente connectée, une demande par navigateur ; le serveur n'envoie qu'une fois, et seulement pour un compte récent. */
(function () {
  var CLE = "fv-notifier";
  function valeur(f, nom) {
    var e = f.elements["contact[" + nom + "]"];
    if (!e || e.disabled) return "";
    return String(e.value || "").trim(); // boutons radio : la valeur cochée
  }
  function envoyer(corps) {
    return fetch("/apps/fiveaven/notifier", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(corps) })
      .catch(function () { /* le formulaire est déjà arrivé : le mail de confirmation est facultatif */ });
  }
  window.fvNotifier = {
    valeur: valeur,
    // à l'envoi du formulaire (après la validation du navigateur) : type de mail, et données propres au formulaire
    garder: function (f, type, donnees) {
      if (!f) return;
      f.addEventListener("submit", function () {
        try { sessionStorage.setItem(CLE, JSON.stringify({ type: type, email: valeur(f, "email"), prenom: valeur(f, "Prénom"), donnees: donnees(f) })); } catch (e) { /* stockage indisponible */ }
      });
    },
    // page « bien reçu » : le mail gardé part une seule fois
    confirmer: function (type) {
      var s = null;
      try { s = JSON.parse(sessionStorage.getItem(CLE) || "null"); sessionStorage.removeItem(CLE); } catch (e) { s = null; }
      if (s && s.type === type) envoyer(s);
    },
    compte: function () {
      try { if (localStorage.getItem("fv-compte-mail")) return; localStorage.setItem("fv-compte-mail", "1"); } catch (e) { return; }
      envoyer({ type: "compte" });
    }
  };
})();
